module.exports = __webpack_public_path__ + "img/default_header_logo.dca9f143.svg";